module.exports = __webpack_public_path__ + "static/media/brookfield-digital.0f73008f.jpg";